// extracted by mini-css-extract-plugin
module.exports = {"iframe__title":"Iframe--iframe__title--2vk-8","iframe__content":"Iframe--iframe__content--2Ddme","iframe__iframe":"Iframe--iframe__iframe--2NDG9"};